import { RelAnalysisGroupInterface } from './../modelli/inwit/analisi/rel-analysis-group.interface';
import { EBWModalResult } from './../library/ebw-modals-angular/model/ebw-modal.model';
import { EbwModalService } from './../library/ebw-modals-angular/ebw-modal.service';
import { faHourglassEnd, faTrash } from '@fortawesome/free-solid-svg-icons';
import { GroupsHandlerService } from './../servizi/groups-handler.service';
import { AnalysisDataAccessService } from 'src/app/servizi/analysis/analysis-data-access.service';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { AnalysisGroupInterface } from '../modelli/inwit/analisi/analysis.interface';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { GestioneUtentiService } from '../servizi/utenti/gestione-utenti.service';

import { ConfigService } from '../servizi/config/config.service';

@Component({
  selector: 'app-analisys-management',
  templateUrl: './analisys-management.component.html',
  styleUrls: ['./analisys-management.component.scss']
})
export class AnalisysManagementComponent implements OnInit {

  // For permissions
  selezionaAnalisiActive: boolean = false;
  selezionaGruppiActive: boolean = false;

  //list autocomplete
  analysis = [];
  groups = [];

  //list groups in ul
  groupsList = [];

  //model input selected
  public model: any;
  public group: any;
  public currentAnalysis: any;

  //icons
  faTrash = faTrash;

  //show ng-container
  showDetail: boolean = false;

  constructor(
    private analysisDataAccessService: AnalysisDataAccessService,
    private groupService: GroupsHandlerService,
    private ebwModal: EbwModalService,
    private gestioneUtentiService: GestioneUtentiService,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    this.getAnalysis();
    this.getGroups();

    this.selezionaAnalisiActive = this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.analysisManagement.analysisManagementSearch);
    this.selezionaGruppiActive = this.gestioneUtentiService.isEnabled(this.configService.getConfigGlobale().permissions.analysisManagement.analysisManagementSearchGroup);
  }

  onSelectedItem(event: NgbTypeaheadSelectItemEvent) {
    // console.log("selected item", event);
    this.currentAnalysis = event.item;
    this.groupsList = [];
    if (this.currentAnalysis.rel_analysis_group.length > 0) {
      let group_ids = this.currentAnalysis.rel_analysis_group.map(x => x.group_id);
      let selected_group = this.groups.filter(x => group_ids.includes(x.id));
      this.groupsList = selected_group;
    }
    this.showDetail = true;
  }


  ngbTypeaheadResultFormatter(item: AnalysisGroupInterface) {
    return item.piano_lavori + ' ' + item.anno_piano_lavori + ' ' + item.nome_sito;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => {
        if (this.currentAnalysis) {
          (x != this.currentAnalysis.piano_lavori || x != this.currentAnalysis.nome_sito) ? this.showDetail = false : null
        }

      }),
      map((term) =>
        term.length < 2
          ? this.analysis
          : this.analysis
            .filter((item) => {
              return (item.piano_lavori.toLowerCase() + ' ' + item.anno_piano_lavori.toLowerCase() + ' ' + item.nome_sito.toLowerCase()).includes(term.toLowerCase())
            }))
    );

  searchGroups = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => console.log("typed: ", x)),
      map((term) =>
        term.length < 2
          ? this.groups
          : this.groups
            .filter((item) => {
              return (item.name.toLowerCase().includes(term.toLowerCase()));
            }))
    );

  onSelectedGroup(event: NgbTypeaheadSelectItemEvent) {
    // console.log("selected item", event);
    if (this.groupsList.indexOf(event.item) == -1) {
      this.addRelAnalysisGroup(event.item);
    }
    this.group = null;
  }
  ngbTypeaheadResultFormatterGroup(item: any) {
    return item.name;
  }

  removeGroup(index, group) {
    this.ebwModal.openConfirmModal({
      title: "Elimina Gruppo",
      content: "Stai per eliminare un gruppo dall'elenco. Continuare?"
    }).result.then(res => {
      if (res == EBWModalResult.Confirm) {

        this.analysisDataAccessService.removeAnalysisGroup({ group_id: group.id, analysis_id: this.currentAnalysis.id, user_id: this.currentAnalysis.user_id }).subscribe(res => {
          this.groupsList.splice(index, 1);
          this.getAnalysis();
        })
      }
    })
  }


  addRelAnalysisGroup(data) {
    let params: RelAnalysisGroupInterface = {
      analysis_id: this.currentAnalysis.id,
      group_id: data.id,
      user_id: this.currentAnalysis.user_id,
    }
    this.analysisDataAccessService.addRelAnalysisGroup(params).subscribe(res => {
      this.getAnalysis();
      this.groupsList.push(data);
    })
  }

  getAnalysis() {
    this.analysisDataAccessService.getCompleteAnalysesOfLoggedUser().subscribe({
      next: (res) => {
        // to do check if error
        this.analysis = res.data;
      },
    })
  }

  getGroups() {
    this.groupService.groupList().subscribe({
      next: (res) => {
        // to do check if error
        if (res && res.data && res.data.length > 0) {
          this.groups = res.data.map(x => x.properties);
        }
      },
    })
  }
}
